
import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row  style={{ justifyContent: "center", paddingBottom: "20px" }}>
      {/* <p style={{'fontSize':'3rem'}}>DAYS I CODE</p> */}
      <GitHubCalendar
        username="AWMprabhat"
        blockSize={15}
        blockMargin={5}
        color="green"
        fontSize={12}
      />
    </Row>
  );
}

export default Github;
